
import Fade from '@mui/material/Fade';
import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------

const NavDropdownPaper = styled('div')(({ theme }) => ({
  ...theme.mixins.paperStyles(theme, { dropdown: true }),
  padding: theme.spacing(3, 3, 3, 3),
  borderRadius: (theme.shape.borderRadius as number) * 2,
  ...(theme.direction === 'rtl' && {
    padding: theme.spacing(5, 4, 1, 1),
  }),
  border: '1px solid',
  borderColor: theme.vars.palette.primary.main,
}));

// ----------------------------------------------------------------------

type NavDropdownProps = React.ComponentProps<'div'> & {
  open?: boolean;
};

export const NavDropdown = styled(({ open, children, ...other }: NavDropdownProps) => (
  <Fade in={open}>
    <div {...other}>
      <NavDropdownPaper>{children}</NavDropdownPaper>
    </div>
  </Fade>
))(({ theme }) => ({
  position: 'absolute',
  top: '100%', // NavLi의 바로 아래
  left: '50%', // NavLi의 중앙에서 시작
  transform: 'translateX(-50%)', // 중앙 정렬
  marginTop: 8, // 약간의 간격
  width: '300px',
  padding: theme.spacing(1.5),
  zIndex: theme.zIndex.drawer * 2,
  maxWidth: theme.breakpoints.values.lg,
}));
